<template>
  <div class="garanties-list">
    <div class="clients__title">
      Assistances souscrites
    </div>

    <GarantiesFilter @submit="onFilterChanged" />

    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <div class="clients__table">
        <template v-if="garanties.data.length > 0">
          <div class="clients__table__item">
            <div class="clients__table__item--cell little_smaller3">Date d'effet</div>
            <div class="clients__table__item--cell">Numéro de contrat</div>
            <div class="clients__table__item--cell small_wider">Nom</div>
            <div class="clients__table__item--cell little_smaller2" v-if="representative_id">Garantie souscrite</div>
            <div class="clients__table__item--cell little_smaller2" v-else>Assistance</div>
            <div class="clients__table__item--cell">Etat</div>
            <div class="clients__table__item--cell">Statut</div>
            <div class="clients__table__item--cell little_wider2">Date de prochaine échéance</div>
            <div class="clients__table__item--cell super_smaller">Prime</div>
            <div class="clients__table__item--cell super_smaller" style="text-align: center;">Quittance</div>
            <div class="clients__table__item--cell super_smaller" style="text-align: center;" v-if="isMutuaide">CP</div>
            <div class="clients__table__item--cell super_smaller" style="text-align: center;" v-if="isMutuaide">Parc
            </div>
            <div class="clients__table__item--cell super_smaller" style="text-align: center;" v-if="isMutuaide">Carte
              assistance</div>
            <div class="clients__table__item--cell super_smaller" style="text-align: center;">Action</div>

            <!--                        <div class="clients__table__item&#45;&#45;cell">Contrat</div>-->
          </div>
          <div class="clients__table__item" v-for='garanty in garanties.data'>
            <div class="clients__table__item--cell little_smaller3">{{ parseDate(garanty) }}</div>
            <div class="clients__table__item--cell">{{ parseNumber(garanty) }}</div>
            <div class="clients__table__item--cell small_wider">{{ parseFullName(garanty) }}</div>
            <div class="clients__table__item--cell little_smaller2">{{ parseTypeGaranty(garanty) }}</div>
            <div class="clients__table__item--cell">{{ parseStateGaranty(garanty) }}</div>
            <div class="clients__table__item--cell">{{ parseStatusGaranty(garanty) }}</div>
            <div class="clients__table__item--cell little_wider2">{{ parseDateEcheance(garanty) }}</div>
            <div class="clients__table__item--cell super_smaller">{{ parsePrice(garanty) }}</div>
            <div class="clients__table__item--cell icon-cell super_smaller" style="text-align: center;">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_quittance_emise(garanty.id)" />
            </div>
            <div class="clients__table__item--cell icon-cell super_smaller" style="text-align: center;"
              v-if="isMutuaide">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_cp(garanty.id)" />
            </div>
            <div class="clients__table__item--cell icon-cell super_smaller" style="text-align: center;"
              v-if="isMutuaide">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_parc_complete(garanty.id)" />
            </div>
            <div class="clients__table__item--cell icon-cell super_smaller" style="text-align: center;"
              v-if="isMutuaide">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_carte_assistance(garanty.id)" />
            </div>
            <div class="clients__table__item--cell icon-cell super_smaller" style="text-align: center;">
              <font-awesome-icon prefix="fas" icon="edit" @click="editAssistance(garanty)" />
            </div>
            <!--                        <div class="clients__table__item&#45;&#45;cell icon-cell">-->
            <!--                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="preview_pdf('garantie/confirmation-pdf/' + garanty.id, '&show_type=stream')"/>-->
            <!--                        </div>-->
          </div>
        </template>
        <template v-else>
          <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
        </template>

      </div>

      <pagination v-if="representative_id" :data="garanties" @pagination-change-page="getRepresentativeGaranties"
        :limit="10">
      </pagination>
      <pagination v-else :data="garanties" @pagination-change-page="getGaranties" :limit="10"></pagination>
    </template>
  </div>
</template>

<script>
import GarantiesFilter from '@/components/GarantiesSouscrites/GarantiesFilter'
import Preloader from '@/components/Preloader'
import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';

export default {
  name: "AssistancesList",
  components: { GarantiesFilter, Preloader },
  mixins: [pdfPreviewMixin],
  data() {
    return {
      garanties: {
        data: []
      },
      filterParams: {
        pdf: 1,
        visible: '1',
      },
      sortParams: {
        sort: 'id|desc',

      },
      isLoading: false,
    }
  },
  computed: {
    mechanic_id() {
      return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
    },
    representative_id() {
      return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
    },
    isMutuaide() {
      return this.$store.getters.isMutuaide;
    },
  },
  watch: {
    'mechanic_id': function () {
      this.getGaranties();
    },
    'representative_id': function () {
      this.getRepresentativeGaranties();
    }
  },
  methods: {
    isDealer() {
      return this.$store.getters.isDealer;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    isGarden() {
      return this.$store.getters.isGarden;
    },
    parseDate(garanty) {
      if (garanty && garanty.effective_date) {
        let day = garanty.datesParse.day_effective,
          month = garanty.datesParse.month_effective,
          year = garanty.datesParse.year_effective;
        return day + "/" + month + '/' + year;
      }

      return ' - ';
    },
    parseNumber(garanty) {
      console.log("garanty", garanty);

      if (!garanty) {
        return ' - ';
      }

      if (garanty.customized_number) {
        return garanty.customized_number;
      }

      if (garanty.quote_number) {
        return garanty.quote_number;
      }

      return ' - ';
    },
    parseDateEcheance(garanty) {
      return ' - ';
    },
    parsePrice(garanty) {
      if (garanty && (garanty.assistance_price !== null && garanty.assistance_price !== undefined)) {
        return this.roundEURWithoutSymbol(garanty.assistance_price) + ' €';
      }
      return (garanty && garanty.price) ? this.roundEURWithoutSymbol(garanty.price) + ' €' : ' - ';
    },
    parseFullName(garanty) {
      if (this.isRepresentative()) {
        return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
      }
      else {
        // if (garanty.client && (+garanty.client.civility === 3)) {
        //     return garanty.client.name_of_signatory || '-';
        // }
        // return (garanty && garanty.last_name) ? garanty.last_name + ' ' + garanty.first_name : ' - ';
        let client = garanty.client;
        if (client) {
          if (client.name_of_signatory)
            return `${client.name_of_signatory}`;
          else {
            if (client.last_name && client.first_name)
              return `${client.last_name} ${client.first_name}`;
            else if (client.last_name)
              return `${client.last_name}`;
            else
              return `${client.first_name}`;
          }
          // if (+client.civility === CLIENT_CIVILITY.SOCIETE.ID) {
          //     return `${client.last_name} ${client.name_of_signatory}`;
          // } else {
          //     return `${client.first_name} ${client.last_name}`;
          // }
        }
      }
    },
    parseTypeGaranty(garanty) {
      if (garanty.garantie_name) {
        return garanty.garantie_name;
      }
      else if (garanty && garanty.type) {
        switch (+garanty.type) {
          case 1: return 'Autocars'; break;
          case 2: return 'Poids Lourds'; break;
          case 3: return 'Taxis, Ambulances, VSL, Corbillards'; break;
          case 4: return 'VU - VL'; break;
          case 5: return 'VUL - 4097'; break;
        }
      }

      return '';
    },
    parseStateGaranty(garanty) {
      if (garanty && garanty.status) {
        // alert(garanty.status);
        if (garanty.status == 'Active' || garanty.status == 'Waiting_Payment' || garanty.status == 'Relance' || garanty.status == 'Formal_Notice')
          return 'En cours';
        else if (garanty.status == 'Inactive') {
          if (!garanty.response)
            return 'Annulé';
          else if (garanty.response == 2 || garanty.response == 4)
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          else if (garanty.response == 5)
            return 'Résilié le ' + this.moment(garanty.effective_date_end).add(1, 'days').format('DD/MM/Y');
          else if (garanty.response == 6)
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
        }
        else if (garanty.status == 'Resiliated' || garanty.status == 'Resiliated_Non_Payment' || garanty.status == 'Resiliated_Expired' || garanty.status == 'Resiliated_Sold') {
          return 'Résilié';
        } else if (garanty.status == 'Expired') {
          return 'Echu';
        }
      }

      return '';
    },
    parseStatusGaranty(garanty) {
      if (garanty && garanty.status) {
        // alert(garanty.payments);
        console.log(garanty.status);

        if (garanty.status == 'Active' && garanty.payments != '')
          return 'Payé';
        else if (garanty.status == 'Relance')
          return 'Relance envoyée';
        else if (garanty.status == 'Waiting_Payment')
          return 'Règlement en attente';
        else if (garanty.status == 'Formal_Notice')
          return 'Mise en demeurre le ' + this.moment(garanty.updated_at).format('DD/MM/Y');
        else if (garanty.status == 'Resiliated')
          return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
        else if (garanty.status == 'Resiliated_Non_Payment')
          return 'Résilié pour non paiement le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
        else if (garanty.status == 'Resiliated_Expired')
          //return 'Résilié à échéance le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          return 'Résilié à échéance';
        else if (garanty.status == 'Resiliated_Sold')
          return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
        else if (garanty.status == 'Inactive') {
          if (!garanty.response)
            return 'Annulé';
          else if (garanty.response == 2)
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          else if (garanty.response == 4)
            return 'Résilié pour non paiement le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          else if (garanty.response == 5)
            return 'Résilié à échéance';
          // return 'Résilié à échéance le ' + this.moment(garanty.effective_date_end).add(1, 'days').format('DD/MM/Y');
          else if (garanty.response == 6)
            return 'Résilié pour vente le ' + (this.moment(garanty.cancellation_date) + 1).format('DD/MM/Y');
        } else if (garanty.status == 'Expired') {
          return 'Payé';
        } else if (garanty.status == 'Regul_Waiting_Payment') {
          return 'Régul. en attente de règlement';
        }
      }

      return '';
    },
    onFilterChanged(filterParams) {
      this.filterParams = filterParams;
      this.$nextTick(() => {
        if (this.representative_id) {
          this.getRepresentativeGaranties();
        }
        else {
          this.getGaranties();
        }
      });
    },
    getGaranties(page = 1) {
      this.isLoading = true;
      let url = 'garantie/assistance-search?page=' + page,
        data = {
          mechanic_id: this.mechanic_id,
          ...this.filterParams,
          ...this.sortParams
        };
      this.apiGet(url, data)
        .then(response => {
          this.isLoading = false;
          this.garanties = response.data;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        })
    },
    getRepresentativeGaranties(page = 1) {
      this.isLoading = true;
      let url = 'mutuaide/representative-search?page=' + page,
        data = {
          representative_id: this.representative_id,
          ...this.filterParams,
          ...this.sortParams
        };
      this.apiGet(url, data)
        .then(response => {
          this.isLoading = false;
          this.garanties = response.data;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        })
    },
    editAssistance(garanty) {
      this.$router.push('/assistances-souscrite/' + garanty.id);
    },
  },
  mounted() {
    if (this.representative_id) {
      this.getRepresentativeGaranties();
    }
    else {
      this.getGaranties();
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/AssistancesList.vue